var prefix = "sparxo-ed61a57d-3242-445d-9249-0b3e72738222:";

export interface IPostMessage {
    frameId: string;
    type: string;
    data?: any;
}
export function postMessage(data: IPostMessage, target = parent, targetOrigin = "*") {
    setTimeout(() => {
        target.postMessage(`${prefix}${JSON.stringify(data)}`, targetOrigin);
    }, 0);
}


// WEBPACK FOOTER //
// ./src/Apps/shared/messager/post.ts